import { Button, Tooltip } from "@mui/material";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import { useCheckAuth } from "../../../../../store/authStore";
import Modal from "@mui/material/Modal";
import { blackButtonContained, modal } from "../../../../../classPresets";
import dayjs, { Dayjs } from "dayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { useState } from "react";
import { exportData } from "../../../../../utils/objectArrayMethods";
import { useLazyQuery } from "@apollo/client";
import { GET_CUSTOMER_PAYMENT_CONDITIONAL_CUSTOMER_POPULATED } from "../../../../../gqls/customer";

export default function TransactionHistory() {
  const checkAuth = useCheckAuth();

  const hasPermission = checkAuth({
    permissionName: "거래내역열람",
    scopeCheck: ["all"],
  });

  const [open, setOpen] = useState(false);
  const [range, setRange] = useState<{
    from: string | Date;
    to: string | Date;
  }>({
    // Initialise with month ago to today
    from: new Date(new Date().setMonth(new Date().getMonth() - 1)),
    to: new Date(),
  });

  const { from, to } = range;
  const handleClose = () => {
    setOpen(false);
  };

  const handleDateChange = (
    where: string,
    value: string | Date | Dayjs | null
  ) => {
    if (where == "from" && dayjs(value).isAfter(dayjs(to))) {
      return;
    }
    if (where == "to" && dayjs(value).isBefore(dayjs(from))) {
      return;
    }

    setRange(prev => ({
      ...prev,
      [where]: value ? value : new Date(),
    }));
  };

  const [get_customer_payments] = useLazyQuery(
    GET_CUSTOMER_PAYMENT_CONDITIONAL_CUSTOMER_POPULATED
  );

  const exportToExcel = async () => {
    const { data } = await get_customer_payments({
      variables: {
        where: {
          created_at: {
            _gte: dayjs(from).startOf("day").toISOString(),
            _lte: dayjs(to).endOf("day").toISOString(),
          },
        },
      },
    });

    if (data && data.customerPayments) {
      const payments = data.customerPayments;

      const refinedExportData = payments.map(payment => {
        return {
          입금일: dayjs(payment.received_at).format("YYYY/MM/DD") || "",
          고객번호:
            `${payment.customer.year}-${payment.customer?.number}` || "",
          고객명: payment.customer?.name || "",
          입금액: payment.amount || 0,
          결제수단: payment.method?.name || "",
          입금메모: payment.comment || "",
          입력자: payment.enteredBy?.name || "",
        };
      });

      exportData(refinedExportData, "거래내역");
    }
  };

  if (!hasPermission) {
    return null;
  }
  return (
    <>
      <div
        onClick={() => {
          setOpen(true);
        }}
        className="bg-white p-[2px] md:p-[6px] rounded-sm ring-1 ring-gray-300 cursor-pointer md:hover:ring-quezone md:hover:text-quezone"
      >
        <Tooltip title="거래내역 내보내기">
          <ReceiptLongIcon />
        </Tooltip>
      </div>

      <Modal open={open} onClose={handleClose}>
        <section className={`${modal}`}>
          <div className="p-4 max-w-full w-[524px] gap-y-2 gap-x-4">
            <h3 className="col-span-1 md:col-span-2 mb-8">거래내역 내보내기</h3>

            <div className="flex flex-col gap-3">
              <div className="flex flex-row justify-between px-2 items-center">
                <div className="text-quezone font-medium text-sm">FROM</div>

                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    format="YYYY/MM/DD"
                    slotProps={{
                      textField: {
                        size: "small",
                        color: "success",
                        variant: "standard",
                      },
                      openPickerButton: {
                        color: "success",
                      },
                    }}
                    value={from ? dayjs(from) : dayjs()}
                    onChange={e => {
                      handleDateChange("from", e);
                    }}
                  />
                </LocalizationProvider>
              </div>

              <div className="flex flex-row justify-between px-2 items-center">
                <div className="text-quezone font-medium text-sm">TO</div>

                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    format="YYYY/MM/DD"
                    slotProps={{
                      textField: {
                        size: "small",
                        color: "success",
                        variant: "standard",
                      },
                      openPickerButton: {
                        color: "success",
                      },
                    }}
                    value={to ? dayjs(to) : dayjs()}
                    onChange={e => {
                      handleDateChange("to", e);
                    }}
                  />
                </LocalizationProvider>
              </div>
            </div>

            <div className="col-span-1 md:col-span-2 flex flex-row justify-end gap-2 mt-8">
              <Button
                variant="outlined"
                size="small"
                color="error"
                onClick={handleClose}
              >
                취소
              </Button>
              <Button
                onClick={exportToExcel}
                size="small"
                {...blackButtonContained}
              >
                내보내기
              </Button>
            </div>
          </div>
        </section>
      </Modal>
    </>
  );
}
